import { useEffect } from "react"
import {
  useSharedValue,
  useAnimatedStyle,
  withTiming,
} from "react-native-reanimated"
import { useStore } from "@nanostores/react"
import { compUpdatingState } from "@/stores/compsDataStore"

function useUpdateDimming(externalIsUpdating?: boolean) {
  const storeIsUpdating = useStore(compUpdatingState)
  // If an external value is provided, use it; otherwise, use the store value.
  const isUpdating =
    externalIsUpdating !== undefined ? externalIsUpdating : storeIsUpdating

  const opacity = useSharedValue(1)

  useEffect(() => {
    opacity.value = withTiming(isUpdating ? 0.5 : 1, {
      duration: 225,
    })
  }, [isUpdating])

  const animatedDimStyle = useAnimatedStyle(() => ({
    opacity: opacity.value,
  }))

  return { animatedDimStyle, isUpdating }
}

export default useUpdateDimming
